export enum MyPaymentsEnum {
	BILLET_DETAILS = '/servicos/meu-financeiro/detalhes-do-boleto',
	PAYMENTS_HISTORY = '/servicos/meu-financeiro/historico-de-pagamentos',
	COPARTICIPATION = '/servicos/meu-financeiro/extrato-de-coparticipacao',
	INCOME_TAX = '/servicos/meu-financeiro/imposto-de-renda',
	OPEN_BILLS = '/servicos/meu-financeiro',
}

export enum AuthorizationsEnum {
	AUTHORIZATIONS_ODONTO = '/servicos/autorizacoes-odonto',
	AUTHORIZATIONS = '/servicos/autorizacoes-saude',
	AUTHORIZATIONS_REQUESTS = '/servicos/autorizacoes-saude/solicitacoes',
	REQUEST_INITIAL_FLOW_UF = '/servicos/autorizacoes-saude/solicitar/estado',
	REQUEST_INITIAL_FLOW_CITY = '/servicos/autorizacoes-saude/solicitar/cidade',
	REQUEST_INITIAL_FLOW_CONTACT = '/servicos/autorizacoes-saude/solicitar/contato',
	REQUEST_INITIAL_FLOW_EMAIL = '/servicos/autorizacoes-saude/solicitar/email',
	REQUEST = '/servicos/autorizacoes-saude/solicitar',
	REQUEST_DETAIL = '/servicos/autorizacoes-saude/detalhe/:id',
	INSTRUCTIONS = '/servicos/autorizacoes-saude/instrucoes',
}

export enum RefundEnum {
	REFUND = '/servicos/reembolso',
	REQUEST = '/servicos/reembolso/solicitar',
	REQUEST_PREVIEW = '/servicos/reembolso/solicitar-previa',
	CONSULT = '/servicos/reembolso/consultar',
	CONSULT_PREVIEW = '/servicos/reembolso/consultar-previa',
	SENDING_DOCUMENTS = '/servicos/reembolso/envio-de-documentos',
	TERMS_PREVIEW = '/servicos/reembolso/termos/solicitar-previa',
	TERMS_DEFAULT = '/servicos/reembolso/termos/:type',
	TERMS_ADDITIONAL_DOCS = '/servicos/reembolso/termos/envio-de-documentos',
	TERMS = '/servicos/reembolso/termos/solicitar',
}

export enum MyReferralsEnum {
	MY_REFERRALS = '/servicos/meus-encaminhamentos',
	MY_REFERRALS_HISTORY = '/servicos/meus-encaminhamentos/historico',
}

export enum ContractAdaptationEnum {
	CONTRACT_ADAPTATION = '/servicos/adaptacao-de-contratos',
}

export enum ContractReactivationEnum {
	CONTRACT_REACTIVATION = '/servicos/reativacao-de-contratos',
}

export enum ChangePlanEnum {
	CHANGE_PLAN = '/servicos/alterar-plano',
	CHANGE_PLAN_HISTORY = '/servicos/alterar-plano/historico',
	CHANGE_PLAN_NEW_PLAN = '/servicos/alterar-plano/escolher-novo-plano',
	CHANGE_PLAN_NEW_PLAN_UF = '/servicos/alterar-plano/escolher-novo-plano/estado',
	CHANGE_PLAN_NEW_PLAN_CITY = '/servicos/alterar-plano/escolher-novo-plano/cidade',
}

export enum ChangeDueDateEnum {
	CHANGE_DUE_DATE = '/servicos/alterar-vencimento',
}

export enum FinancialPendencyEnum {
	FINANCIAL_PENDENCY = '/inadimplencia',
}
